export default {
  CONSENT_TEXT:
    'By providing the mobile number below, you consent to receive calls or texts relating to this visit at that number.',
  BOOK_APPOINTMENT: {
    ERROR: {
      severity: 'error' as 'error',
      title: 'Booking Error',
      description: 'There was an issue booking the appointment.'
    }
  },
  CONSENT_STATE_TEXT:
    'By booking this appointment you are agreeing to the fact that you will be in one of the states listed here:'
};
